import React, { Component, createRef } from "react";
import { withRouter } from 'react-router-dom';
import "./index.css"
import moment from "moment";
import axios from 'axios';
import GenAIAuthoring2ResultIndex from './GenAIAuthoring2.0ResultIndex';
import { Modal } from "react-bootstrap";
import { imsLoader, GenAiExcelIcon, GenAiDOCIcon, GenAiPDFIcon, GenAiPPTIcon } from '../../assets/index';
import threadingService from "../../services/threadingService";
import authoringProjectService from "../../services/AuthoringProjectService";
import trackingService from "../../services/trackingService";
import { LocationOrigin, getCurrentDate, multiFilesAccept } from '../../utils/utilityServices';
import { GenAIAnsweringContext } from './GenAIAnsweringContextProvider';
import { v4 as uuidv4 } from 'uuid';
import { showMenu } from "react-contextmenu";
import ApiServices from "../../utils/apiServices";
import { clone } from 'underscore'
import {
    UserData
} from "../../auth/Authorization";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import ShareTemplateModal from "../PopUp/ShareThreadModal";
import IdleTimer from 'react-idle-timer';
import Button from "../Button";
import GenAIClose from "./GenAIClose";
import GenAIAnsweringDisclaimer from './GenAIAnsweringDisclaimer'
import { Authentication } from "../../utils/authenticationUtilityServices";
import GenAIAnsweringHTMLNotebook from "./GenAIAnsweringHTMLNotebook";
import * as FileSaver from 'file-saver';
import ReactDOMServer from "react-dom/server";
import PromptTemplateListPopUpAuth2 from "../PopUp/PromptTemplateLIstPopUpAuth2.0";

let ts = new threadingService();
let aps = new authoringProjectService();
let api = new ApiServices();


let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';

const ReactNone = 'None';
let _timeoutTime = (1000 * (300));
const columns = [
    {
        "header": "Sl No",
        "key": "Sl No",
        "width": 10
    },
    {
        "header": "Question",
        "key": "Question",
        "width": 50
    },
    {
        "header": "Answer",
        "key": "Answer",
        "width": 50
    },
    {
        "header": "Reading Level",
        "key": "ReadingLevel",
        "width": 20
    },
    {
        "header": "Word Limit",
        "key": "WordLimit",
        "width": 20
    }
]
class GenAIAuthoring2SearchIndex extends Component {
    static contextType = GenAIAnsweringContext;

    constructor(props) {
        super(props);
        this.messagesEnd = createRef();
        this.myDiv = createRef();
        this.inputRef = React.createRef();
        var _timeout = 600;
        this.idleTimer = null;

        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            sessionID: props.location.state ? props.location.state.sessionID : (props.match.params && props.match.params.id) ? props.match.params.id : null,
            question: props.location.state ? props.location.state.newQuestion : null,
            attachedFiles: props.location.state ? props.location.state.attachedFiles : [],
            threadID: props.location.state ? props.location.state.threadID : null,
            isRedirectOnGenAISearch: props.location.state ? props.location.state.isRedirectOnGenAISearch : false,
            uploadFilePlaceHolder: "",
            uploadFilePlaceHolderTitle: "",
            isAttachedFile: false,
            newQuestion: "",
            chatConversation: [],
            isProcessing: false,
            chatHistory: [],
            attachedFilePopupCollapsed: false,
            scrollingUp: false,
            isFirstQuestion: true,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            newAttachedFiles: [],
            removedAttachedFileIndex: -1,
            spinnerMessage: '',
            timeout: 1000 * _timeout,
            isTimeOut: false,
            updateAnyFile: (props.location.state && props.location.state.attachedFiles && props.location.state.attachedFiles.length > 0) ? true : false,
            isMultiFileThread: (props.location.state ? props.location.state.attachedFiles : []).length > 0,
            showDisclaimerPopup: false,
            systemPromptTemplates: [],
            showPromptTemplateList: false,
            isUserPromptTemplate: false,
            isSystemPromptTemplate: true,
            isFromGlobalFeaturesMenu: false,
            isMultiQuestionProcessing: false,
            shareModal: false,
            scrollToBottomRandom: Math.random(),
            projectName: props.location.state ? props.location.state.projectName : null,
            projectType: props.location.state ? props.location.state.projectType : null,
            prompts: props.location.state ? props.location.state.prompts : [],
            docProcessing: false,
            saveFormat: '',
        }
        this.onIdle = this._onIdle.bind(this)
    }
    componentDidMount = async () => {
        window.addEventListener('scroll', this.handleScroll, true);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        await this.getSystemPromptTemplates();
        if ((this.props.location.state && this.props.location.state.sessionID) || (this.props.match.params && this.props.match.params.id)) {
            await this.getAuthoringProjectDataBySessionId(this.state.sessionID);

            let { sessionID, attachedFiles } = this.state;
            if (attachedFiles.length > 0) {
                this.context.updateSessionId(sessionID);
            } else {
                this.context.updateSessionId("");
            }
        } else {
            this.props.history.push('/genAIAnswering');
        }


        this.manageFilePlaceHolder();

    }
    getSystemPromptTemplates = async () => {
        this.setState({ isProcessing: true });
        const service = new ApiServices();
        let { customWidth } = this.state;
        let _limit = 3;
        if (customWidth < 1300) {
            _limit = 2;
        }
        let _systemPromptTemplates = await service.getSystemPromptTemplatesForTextArea(_limit);
        if (_systemPromptTemplates.length > 0) {
            this.setState({ systemPromptTemplates: _systemPromptTemplates });
        } else {
            this.setState({ systemPromptTemplates: [] });
        }

    }
    handleBeforeUnload = async () => {
        let { sessionID, attachedFiles } = this.state;
        if (attachedFiles.length > 0) {
            sessionStorage.setItem("GenAIAnsweringSessionId", sessionID);
        }
        else {
            sessionStorage.removeItem("GenAIAnsweringSessionId");
        }
    }

    async componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
        let { sessionID, attachedFiles, isRedirectOnGenAISearch } = this.state;
        if (attachedFiles.length > 0 && !isRedirectOnGenAISearch) {
            await ts.deleteIndexBySessionId(sessionID);
        }
        await this.context.updateSessionId("");
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
    async componentWillReceiveProps(nextProps) {
        if ((nextProps.match.params && nextProps.match.params.id && this.state.sessionID !== nextProps.match.params.id)) {
            let { sessionID, attachedFiles } = this.state;
            if (attachedFiles.length > 0) {
                await ts.deleteIndexBySessionId(sessionID);
            }

            this.setState({
                sessionID: nextProps.match.params.id,
                question: "",
                attachedFiles: [],
                newQuestion: "",
                chatConversation: [],
                chatHistory: [],
                attachedFilePopupCollapsed: false,
                isFirstQuestion: true,
                updateAnyFile: false,
            }, async () => {
                await this.context.updateSessionId("");
                await this.getAuthoringProjectDataBySessionId(this.state.sessionID);
            })
        }

        if (nextProps
            && nextProps.location
            && nextProps.location.state
            && nextProps.location.state.sessionID
            && this.state.sessionID !== nextProps.location.state.sessionID) {
            let { sessionID, attachedFiles } = this.state;
            if (attachedFiles.length > 0) {
                await ts.deleteIndexBySessionId(sessionID);
            }
            this.setState({
                sessionID: nextProps.location.state.sessionID,
                question: nextProps.location.state.newQuestion,
                attachedFiles: nextProps.location.state.attachedFiles,
                threadID: nextProps.location.state.threadID,
                newQuestion: "",
                chatConversation: [],
                chatHistory: [],
                attachedFilePopupCollapsed: false,
                isFirstQuestion: true,
                updateAnyFile: (nextProps.location.state && nextProps.location.state.attachedFiles && nextProps.location.state.attachedFiles.length > 0) ? true : false
            }, async () => {
                if (nextProps.location.state.attachedFiles.length > 0) {
                    await this.context.updateSessionId(nextProps.location.state.sessionID);
                } else {
                    this.context.updateSessionId("");
                }
                let { attachedFiles, prompts } = this.state;
                if (attachedFiles.length > 0 && prompts.length > 0) {
                    this.processMultiPrompts(prompts);
                }
            })
        }

    }

    async getAuthoringProjectDataBySessionId(sessionID) {
        this.setState({ isProcessing: true })
        if (UserData && UserData.sub) {
            let response = await aps.getAuthoringProjectDataBySessionId(UserData.sub, sessionID)
            if (response && response.data.length > 0) {
                let _chatConversation = this.state.chatConversation;
                let { chatHistory } = this.state;
                let _question = "", _attachedFiles = [], _threadID = '', _isMultiFileThread = false,
                    _threadAttachedFiles = [], _projectName = "", _projectType = "", _prompts = [];
                let threadGuid = uuidv4();
                response.data.forEach((threadItem, threadIndex) => {
                    _threadAttachedFiles = [];
                    let source = threadItem._source;
                    let _chatHistoryThreadID = '';
                    if (threadIndex === 0) {
                        _question = source.authoringinfo.question;
                        if (source.authoringinfo.projectName) {
                            _projectName = source.authoringinfo.projectName;
                        }
                        if (source.authoringinfo.projectType) {
                            _projectType = source.authoringinfo.projectType;
                        }

                    }
                    if (threadIndex === (response.data.length - 1)) {
                        if (source.authoringinfo.attachedFiles) {
                            _attachedFiles = source.authoringinfo.attachedFiles;
                        }
                        if (source.authoringinfo.thread_id && _attachedFiles.length === 0) {
                            _threadID = source.authoringinfo.thread_id;
                        } else {
                            _threadID = threadGuid;
                        }
                        _isMultiFileThread = _attachedFiles.length > 0;
                    }
                    if (source.authoringinfo.attachedFiles && source.authoringinfo.attachedFiles.length > 0) {
                        _threadAttachedFiles = clone(source.authoringinfo.attachedFiles);
                    }
                    if (source.authoringinfo.thread_id) {
                        _chatHistoryThreadID = source.authoringinfo.thread_id;
                    }
                    if (source.authoringinfo.output_answer) {
                        chatHistory.push({ question: source.authoringinfo.question, answer: source.authoringinfo.output_answer, threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID });
                    } else {
                        chatHistory.push({ question: source.authoringinfo.question, answer: "", threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID });
                    }
                    _prompts.push({
                        prompt: source.authoringinfo.question,
                        wordLimit: source.authoringinfo.wordLimit ? source.authoringinfo.wordLimit : '',
                        readingLevel: source.authoringinfo.readingLevel ? source.authoringinfo.readingLevel : ''
                    })
                    _chatConversation.push({
                        IsSucceed: true,
                        Question: source.authoringinfo.question,
                        OutputAnswer: source.authoringinfo.output_answer,
                        messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment },
                        questionType: source.authoringinfo.question_type,
                        eventid: source.eventinfo.eventid,
                        isMultiFiles: source.authoringinfo.attachedFiles.length > 0,
                        DisplayStringMultiFiles: source.authoringinfo.display_string_multi_files ? source.authoringinfo.display_string_multi_files : [],
                        SourcesMultiFiles: source.authoringinfo.sources_multi_files_list ? source.authoringinfo.sources_multi_files_list : [],
                        combinedSummaryMultiFiles: source.authoringinfo.combined_summary_multi_files
                            ? source.authoringinfo.combined_summary_multi_files : source.authoringinfo.combined_summary_multi_files_list
                                ? source.authoringinfo.combined_summary_multi_files_list : "",
                        threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID,
                        Reaction: source.authoringinfo.answer_reaction ? source.authoringinfo.answer_reaction : ReactNone,
                        Feedback: source.authoringinfo.answer_feedback ? source.authoringinfo.answer_feedback : '',
                        isGetAnyAns: source.authoringinfo.isGetAnyAns,
                        isSuccess: source.authoringinfo.isSuccess,
                        lastCreatedDatehour: source.authoringinfo.lastcreateddatehour ? source.authoringinfo.lastcreateddatehour : source.eventinfo.createddatehour,
                        threadAttachedFiles: _threadAttachedFiles,
                        finalPrompt: source.authoringinfo.finalPrompt ? source.authoringinfo.finalPrompt : '',
                        wordLimit: source.authoringinfo.wordLimit ? source.authoringinfo.wordLimit : '',
                        readingLevel: source.authoringinfo.readingLevel ? source.authoringinfo.readingLevel : '',
                    })
                })
                if (_isMultiFileThread && !this.state.isRedirectOnGenAISearch) {
                    await ts.deleteIndexBySessionId(sessionID);
                }

                this.setState({
                    chatConversation: _chatConversation,
                    isProcessing: false,
                    newQuestion: '',
                    chatHistory: chatHistory,
                    isFirstQuestion: false,
                    question: _question,
                    //attachedFiles: _attachedFiles,
                    threadID: _threadID ? _threadID : sessionID,
                    isMultiFileThread: _isMultiFileThread,
                    isRedirectOnGenAISearch: false,
                    projectName: _projectName,
                    projectType: _projectType,
                    prompts: _prompts,
                }, async () => {
                    this.scrollToBottom();
                    //this.updateAuthoringProjectDatehour();
                })

            }
            else if (this.props.location.state && this.props.location.state.sessionID && this.props.location.state.newQuestion) {
                let { attachedFiles, prompts } = this.state;
                if (attachedFiles.length > 0 && prompts.length > 0) {
                    this.processMultiPrompts(prompts);
                }
            } else {
                this.props.history.push('/GenAIAuthoring2');
            }
        } else {
            this.props.history.push('/GenAIAuthoring2');
        }
    }

    getInformationForExcel() {
        let csvData = []
        let { chatConversation } = this.state;
        let _chatConversation = JSON.parse(JSON.stringify(chatConversation))
        if (_chatConversation && _chatConversation.length > 0) {
            _chatConversation.forEach((ele, index) => {
                let _textDisplayString = ''
                if (ele.DisplayStringMultiFiles && ele.DisplayStringMultiFiles.length > 0) {
                    ele.DisplayStringMultiFiles.forEach((ans) => {
                        ans.display_ans = ans.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                        ans.display_ans = ans.display_ans.replace(/<li>/g, '\n- <li>');
                        let regex = /<\/ul>/i;
                        ans.display_ans = ans.display_ans.replace(regex, '</ul>');
                        _textDisplayString += ans.display_ans.replace(/(<([^>]+)>)/ig, '') + '\n';
                    })
                    csvData.push({ "Sl No": index + 1, Question: ele.Question, Answer: _textDisplayString, ReadingLevel: ele.readingLevel, WordLimit: ele.wordLimit })
                } else {
                    csvData.push({ "Sl No": index + 1, Question: ele.Question, Answer: "No Answer found. Please try a new question.", ReadingLevel: ele.readingLevel, WordLimit: ele.wordLimit })
                }
            })
        }
        return csvData
    }

    indextrackingData = async (eventid, questionType, question, userQuestion, outputAnswer, attachedFiles, sourcesMultiFiles, displayStringMultiFiles, combinedSummaryMultiFiles, lastCreatedDatehour, isMultiQuestion, finalPrompt, wordLimit, readingLevel, isGetAnyAns, isSuccess) => {
        let { sessionID, threadID, projectName, projectType } = this.state;
        let authoringinfo = {
            session_id: sessionID,
            thread_id: threadID,
            question_type: questionType,
            question: question,
            userQuestion: userQuestion ? userQuestion : question,
            output_answer: outputAnswer,
            isGetAnyAns: isGetAnyAns,
            isSuccess: isSuccess,
            attachedFiles: attachedFiles,
            sources_multi_files_list: sourcesMultiFiles,
            display_string_multi_files: displayStringMultiFiles,
            combined_summary_multi_files_list: combinedSummaryMultiFiles,
            answer_reaction: ReactNone,
            answer_feedback: '',
            lastcreateddatehour: lastCreatedDatehour,
            projectName: projectName,
            projectType: projectType,
            finalPrompt: finalPrompt,
            wordLimit: wordLimit,
            readingLevel: readingLevel,
        }
        await aps.indextrackingData("Conducted Question GenAIAuthoring2.0", eventid, authoringinfo);
        this.indexData({ ...authoringinfo, "eventid": eventid, "isMultiQuestion": isMultiQuestion });
        setTimeout(async () => {
            if (questionType === "FollowUpQuestion") {
                await this.updateAuthoringProjectDatehour(attachedFiles.length > 0);
            }
        }, 600);
    }
    updateAuthoringProjectData = async (newEventid, eventid, questionType, question, userQuestion, outputAnswer, attachedFiles, sourcesMultiFiles, displayStringMultiFiles, combinedSummaryMultiFiles, lastCreatedDatehour, finalPrompt, wordLimit, readingLevel, isGetAnyAns, isSuccess) => {
        let { sessionID, threadID, projectName, projectType } = this.state;
        let authoringinfo = {
            session_id: sessionID,
            thread_id: threadID,
            question_type: questionType,
            question: question,
            userQuestion: userQuestion ? userQuestion : question,
            output_answer: outputAnswer,
            isGetAnyAns: isGetAnyAns,
            isSuccess: isSuccess,
            attachedFiles: attachedFiles,
            sources_multi_files_list: sourcesMultiFiles,
            display_string_multi_files: displayStringMultiFiles,
            combined_summary_multi_files_list: combinedSummaryMultiFiles,
            answer_reaction: ReactNone,
            answer_feedback: '',
            lastcreateddatehour: lastCreatedDatehour,
            projectName: projectName,
            projectType: projectType,
            finalPrompt: finalPrompt,
            wordLimit: wordLimit,
            readingLevel: readingLevel,
        }
        await aps.updateAuthoringProjectData(eventid, newEventid, authoringinfo);
        this.indexData({ ...authoringinfo, "eventid": newEventid });
        if (questionType === "FollowUpQuestion") {
            setTimeout(async () => {
                await this.updateAuthoringProjectDatehour(false);
            }, 500);
        }
    }


    indexData = (genaiAuthoring2info) => {
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            `Conducted Question Authoring2.0`,
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, genaiAuthoring2info);
    }


    indexShareData = (sharedToEmail) => {
        let { sessionID } = this.state;
        let shared_from_wwid = JSON.parse(localStorage.getItem('wwid'));
        let shared_from_email = JSON.parse(localStorage.getItem('username'));
        let shared_from_name = JSON.parse(localStorage.getItem('userdisplayName'));
        let authoringinfo = {
            session_id: sessionID,
            sharedToEmail: sharedToEmail,
            sharedfromwwid: shared_from_wwid,
            sharedfromemail: shared_from_email,
            sharedfromname: shared_from_name,
            issharedthread: true
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            `Share Thread Answering2.0`,
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, authoringinfo);
    }


    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }

    updateAuthoringProjectDatehour = async (isMultiQuestion) => {
        let { sessionID } = this.state;
        if (!isMultiQuestion) {
            await aps.updateAuthoringProjectDatehour(UserData.sub, sessionID);
        }
    }
    handleKeyDown = async (event) => {

        if (['Enter'].includes(event.key) && !event.shiftKey && this.state.newQuestion && this.state.newQuestion.trim()) {
            event.preventDefault();
            event.returnValue = false;
            await this.handleOnClickSend();
        }
    }
    processChatHistories = (index) => {
        let { attachedFiles, chatConversation, threadID, sessionID } = this.state;
        let _chatHistories = {};
        let _chatConversation = Object.assign([], chatConversation);
        _chatConversation = _chatConversation.filter((x, i) => i < index).filter(x => x.threadID === threadID);
        if (chatConversation.length !== 0 && _chatConversation.length === 0 && index !== 0) {
            _chatConversation = Object.assign([], chatConversation);
            _chatConversation = _chatConversation.filter(x => x.threadID === threadID);
        }
        try {
            if (attachedFiles.length > 0) {
                let isImageUpload = attachedFiles.some(x =>
                    x.name.toLowerCase().endsWith('.gif')
                    || x.name.toLowerCase().endsWith('.jpeg')
                    || x.name.toLowerCase().endsWith('.jpg')
                    || x.name.toLowerCase().endsWith('.png'))
                attachedFiles.forEach((fileItem) => {
                    _chatHistories[fileItem.guid] = [];
                    let responseFilters = _chatConversation.filter(x => x.SourcesMultiFiles.findIndex(y => y.document_guid === fileItem.guid) > -1);
                    responseFilters.forEach((resItem) => {
                        let indexOfSource = resItem.SourcesMultiFiles.findIndex(y => y.document_guid === fileItem.guid)
                        let restDisplayStringMultifilter = resItem.DisplayStringMultiFiles.filter(d => d.source_no.includes(indexOfSource + 1));
                        if (isImageUpload) {
                            restDisplayStringMultifilter = resItem.DisplayStringMultiFiles;
                        }
                        let finalAns = restDisplayStringMultifilter.map(x => x.display_ans).join(' ')
                        _chatHistories[fileItem.guid].push({ "Question": resItem.Question, "Answer": finalAns })
                    })
                })
            } else {
                _chatHistories[sessionID] = [];
                _chatConversation = _chatConversation.filter(x => x.isMultiFiles === false);
                _chatConversation.forEach((resItem) => {
                    let finalAns = resItem.DisplayString.map(x => x.display_ans).join(' ');
                    _chatHistories[sessionID].push({ "Question": resItem.Question, "Answer": finalAns })
                })
            }
        } catch (error) {
            console.log(error)
        }
        return _chatHistories;
    }

    handelClickOnSystemPromptTemplateShortcut = (prompt) => {
        this.setState({ newQuestion: prompt })

    }
    handleClosePromptTemplateList = () => {
        this.setState({
            showPromptTemplateList: false,
            isUserPromptTemplate: false,
            isSystemPromptTemplate: true,
            isFromGlobalFeaturesMenu: false,
        });
    }
    handleClickOnPromptTemplate = () => {
        this.setState({
            isUserPromptTemplate: false,
            isSystemPromptTemplate: true,
            showPromptTemplateList: true,
            isFromGlobalFeaturesMenu: true,
            attachedFilePopupCollapsed: false,
        })
    }
    handleAddToPromptTemplateText = (prompt) => {
        this.setState({ newQuestion: prompt, showPromptTemplateList: false })
    }
    renderSystemPromptTemplateShortcut = () => {
        let { systemPromptTemplates } = this.state;
        if (systemPromptTemplates && systemPromptTemplates.length > 0) {
            return (<div className="gen-ai-answering-prompt-template-shortcut">
                <span className="gen-ai-answering-prompt-template-shortcut-label">Prompt Templates:</span>
                {systemPromptTemplates.map((item, index) => {
                    return (<button type="button" title={item.template_name} onClick={(e) => { this.handelClickOnSystemPromptTemplateShortcut(item.prompt) }} key={`gen-ai-answering-prompt-template-shortcut-item-${index}`} className="gen-ai-answering-prompt-template-shortcut-item">{item.template_short_name}</button>)
                })}
                <button type="button" onClick={() => { this.handleClickOnPromptTemplate() }} className="gen-ai-answering-prompt-template-shortcut-label">More…</button>
            </div>)
        } else {
            return (<>
            </>)
        }
    }
    updateRunGenAISearch = async (question, indexQuestion, updatedQuestionEventid, updatedWordLimit, updatedReadingLevel) => {
        let { sessionID, chatHistory, attachedFiles, threadID, prompts } = this.state;
        if (attachedFiles.length > 0) {
            this.setState({ isProcessing: true })
            let _lastCreatedDatehour = getCurrentDate();
            let _chatHistory = [];
            let url = '';
            let query = question.trim();

            let _question = "";
            if (updatedReadingLevel) {
                _question += `Answer this question about the study as if you were a medical writer explaining to an ${updatedReadingLevel}th grader`
            }
            _question += ` "${question.trim()}" Use simple language`
            if (updatedWordLimit) {
                _question += ` and less than ${updatedWordLimit} words`
            }

            let _threadAttachedFiles = clone(attachedFiles.map(x => { return { name: x.name } }));

            url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
            if (window.location.origin === 'https://predev-ims.jnj.com') {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
            }
            query = [_question.trim()];
            _chatHistory = this.processChatHistories(indexQuestion);
            var config;
            var eventid = uuidv4();
            let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
            let _function = localStorage.getItem('function').replace(/"/g, '');
            const _headers = {
                'Content-Type': 'application/json'
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "query": query,
                    "filters": "",
                    "function": _function,
                    "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                    "userproducts": localStorage.getItem('userproducts'),
                    "region": localStorage.getItem('region'),
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                    "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                    "from": 0,
                    "size": 7,
                    "sortBy": "",
                    "sortField": "",
                    "defaultOperator": "or",
                    "sessionID": sessionID,
                    "threadID": threadID,
                    "chat_history": _chatHistory,
                    "sourceSearchId": [],
                    "isMoreInformation": false,
                    "isFirstQuestion": indexQuestion === 0,
                },
                timeout: _timeoutTime
            }
            let _chatConversation = this.state.chatConversation;
            axios(config)
                .then((resp) => {
                    let response = resp.data[0];
                    if (response.display_string_multi && response.display_string_multi.length > 0) {
                        if (response.output_answer) {
                            chatHistory[indexQuestion] = { question: question, answer: response.output_answer, threadID: threadID };
                        } else {
                            chatHistory[indexQuestion] = { question: question, answer: "", threadID: threadID };
                        }
                        _chatConversation[indexQuestion] = { IsSucceed: true, Question: question, OutputAnswer: response.output_answer, SourcesMultiFiles: response.sources_multi, DisplayStringMultiFiles: response.display_string_multi, messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: indexQuestion === 0 ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, finalPrompt: _question, wordLimit: `${updatedWordLimit}`, readingLevel: `${updatedReadingLevel}`, isGetAnyAns: true, isSuccess: true };

                        this.updateAuthoringProjectData(eventid, updatedQuestionEventid, indexQuestion === 0 ? "MainQuestion" : "FollowUpQuestion", question, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, _question, `${updatedWordLimit}`, `${updatedReadingLevel}`, true, true);
                    } else {
                        _chatConversation[indexQuestion] = { IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: indexQuestion === 0 ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, finalPrompt: _question, wordLimit: `${updatedWordLimit}`, readingLevel: `${updatedReadingLevel}`, isGetAnyAns: false, isSuccess: true }
                        this.updateAuthoringProjectData(eventid, updatedQuestionEventid, indexQuestion === 0 ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, _question, `${updatedWordLimit}`, `${updatedReadingLevel}`, false, true);
                    }


                })
                .catch((error) => {
                    chatHistory[indexQuestion] = { question: question, answer: "", threadID: threadID };
                    _chatConversation[indexQuestion] = { IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: indexQuestion === 0 ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, finalPrompt: _question, wordLimit: `${updatedWordLimit}`, readingLevel: `${updatedReadingLevel}`, isGetAnyAns: false, isSuccess: false };
                    this.updateAuthoringProjectData(eventid, updatedQuestionEventid, indexQuestion === 0 ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, _question, `${updatedWordLimit}`, `${updatedReadingLevel}`, false, false);
                    console.log("error", error);
                })
                .finally(async () => {
                    if (prompts && prompts.length > indexQuestion) {
                        prompts[indexQuestion] = {
                            prompt: question.trim(),
                            wordLimit: updatedWordLimit,
                            readingLevel: updatedReadingLevel
                        }
                    }
                    this.setState({
                        chatConversation: _chatConversation,
                        isProcessing: false,
                        newQuestion: '',
                        chatHistory: chatHistory,
                        isFirstQuestion: false,
                        question: indexQuestion === 0 ? question.trim() : this.state.question,
                        prompts: prompts,
                    }, async () => {
                        //this.scrollToBottom();
                    })
                });

        } else {
            this.errorAlertMessage("Kindly re-upload documents.");
        }
    }
    processFollowUpMultiPrompts = async (newPrompts) => {
        let { prompts } = this.state;
        let _updatePrompts = prompts.concat(newPrompts);
        this.setState({ showPromptTemplateList: false, prompts: _updatePrompts }, async () => {
            await this.processMultiPrompts(newPrompts);
        });
    }

    processMultiPrompts = async (question) => {
        let { attachedFiles } = this.state;
        let _splitQuery = question;
        let questionBatchSize = 3;
        if (attachedFiles.length > 3) {
            questionBatchSize = 1;
        }
        else if (attachedFiles.length > 1) {
            questionBatchSize = 2;
        }
        let totalquestionBatchs = Math.ceil(_splitQuery.length / questionBatchSize);
        this.setState({ isProcessing: true })
        for (let i = 0; i < totalquestionBatchs; i++) {
            let _batch = _splitQuery.slice(i * questionBatchSize, (i * questionBatchSize) + questionBatchSize);
            await this.runGenAIMultiPromptsSearch(_batch);
            this.setState({ isMultiQuestionProcessing: true, isProcessing: false }, () => {
                if (i === 0) {
                    this.scrollToBottom();
                }
            })
        }
        this.setState({ isMultiQuestionProcessing: false })
    }
    runGenAIMultiPromptsSearch = async (question) => {
        let { sessionID, chatHistory, isFirstQuestion, attachedFiles, threadID, isMultiFileThread } = this.state;
        let _chatConversation = this.state.chatConversation;
        let _lastCreatedDatehour = getCurrentDate();
        let url = '';
        let _chatHistory = [];
        //let query = question;
        let query = question.map(x => {
            let finalAns = "";
            if (x.readingLevel) {
                finalAns += `Answer this question about the study as if you were a medical writer explaining to an ${x.readingLevel}th grader`
            }
            finalAns += ` "${x.prompt}" Use simple language`
            if (x.wordLimit) {
                finalAns += ` and less than ${x.wordLimit} words`
            }
            return finalAns;
        })
        let _threadAttachedFiles = clone(attachedFiles.map(x => { return { name: x.name } }));
        if (!isMultiFileThread || (isMultiFileThread && attachedFiles.length > 0)) {


            url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
            if (window.location.origin === 'https://predev-ims.jnj.com') {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
            }

            _chatHistory = this.processChatHistories(_chatConversation.length);
            var config;
            var eventid = uuidv4();
            let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
            //let strChatHistory = chatHistory.map(y => `("${y.question.replace(/'/g, "\'")}","${y.answer.replace(/'/g, "\'")}")`).join(",");
            let _function = localStorage.getItem('function').replace(/"/g, '');
            const _headers = {
                'Content-Type': 'application/json'
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "query": query,
                    "filters": "",
                    "function": _function,
                    "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                    "userproducts": localStorage.getItem('userproducts'),
                    "region": localStorage.getItem('region'),
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                    "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                    "from": 0,
                    "size": 7,
                    "sortBy": "",
                    "sortField": "",
                    "defaultOperator": "or",
                    "sessionID": sessionID,
                    "threadID": threadID,
                    "chat_history": _chatHistory,
                    "sourceSearchId": [],
                    "isMoreInformation": false,
                    "isFirstQuestion": _chatConversation.length === 0,
                },
                timeout: _timeoutTime
            }
            await axios(config)
                .then(async (resp) => {

                    question.forEach((questionItem, questionIndex) => {
                        let response = resp.data[questionIndex];
                        let singleQuery = query[questionIndex];
                        if (response.display_string_multi && response.display_string_multi.length > 0) {
                            _chatConversation.push({ IsSucceed: true, Question: questionItem.prompt, OutputAnswer: response.output_answer, SourcesMultiFiles: response.sources_multi, DisplayStringMultiFiles: response.display_string_multi, messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, finalPrompt: singleQuery, wordLimit: `${questionItem.wordLimit}`, readingLevel: `${questionItem.readingLevel}`, isGetAnyAns: true, isSuccess: true })
                            this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem.prompt, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `${questionItem.wordLimit}`, `${questionItem.readingLevel}`, true, true);
                        } else {
                            _chatConversation.push({ IsSucceed: false, Question: questionItem.prompt, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, finalPrompt: singleQuery, wordLimit: `${questionItem.wordLimit}`, readingLevel: `${questionItem.readingLevel}`, isGetAnyAns: false, isSuccess: true })
                            this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem.prompt, questionItem.prompt, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, query.length > 1, singleQuery, `${questionItem.wordLimit}`, `${questionItem.readingLevel}`, false, true);
                        }
                        eventid = uuidv4();
                    })
                    await aps.updateAuthoringProjectDatehour(UserData.sub, sessionID);
                })
                .catch(async (error) => {
                    question.forEach((questionItem, questionIndex) => {
                        let singleQuery = query[questionIndex];
                        _chatConversation.push({ IsSucceed: false, Question: questionItem.prompt, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, finalPrompt: singleQuery, wordLimit: `${questionItem.wordLimit}`, readingLevel: `${questionItem.readingLevel}`, isGetAnyAns: false, isSuccess: false })
                        this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem.prompt, questionItem.prompt, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, query.length > 1, singleQuery, `${questionItem.wordLimit}`, `${questionItem.readingLevel}`, false, false);
                        eventid = uuidv4();
                    })
                    await aps.updateAuthoringProjectDatehour(UserData.sub, sessionID);
                    console.log("error", error);
                })
                .finally(async () => {
                    this.setState({
                        chatConversation: _chatConversation,
                        newQuestion: '',
                        chatHistory: chatHistory,
                        isFirstQuestion: false
                    }, async () => {
                        // this.scrollToBottom();
                    })
                });
        }
        else {
            this.errorAlertMessage("Kindly re-upload documents.");
        }
    }


    generateDownloadTimestamp = () => {
        const now = new Date()
        return now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "_" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds()
    }

    handleExportToExcel = async () => {
        let { projectName, projectType } = this.state;
        let csvData = this.getInformationForExcel()
        let fileName = `iMS_Project_Details_Download_${this.generateDownloadTimestamp()}.xlsx`;
        this.setState({ isProcessing: true, spinnerMessage: 'Please Wait While Downloding Excel File' });
        await api.prepareExcelDocumentProjects({
            "csvData": csvData,
            "columns": columns,
            "downloadFile": "Excel",
            "worksheetName": "iMS_Project_details_Excel",
            "projectName": projectName,
            "projectType": projectType,
        }).then((res) => {
            const data = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(data, fileName);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            this.setState({ isProcessing: false, spinnerMessage: '' });
        });
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
        this.setState({ scrollToBottomRandom: Math.random() });
    }
    multipleFilesUpload = async (e) => {
        this.setState({ isProcessing: true, spinnerMessage: "Please wait while uploading the document.", focusDropDownCollapsed: false, attachedFilePopupCollapsed: false });
        let { attachedFiles, sessionID, updateAnyFile, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        }
        const formData = new FormData();
        attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).forEach((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).length);
        formData.append(`sessionID`, sessionID);
        formData.append(`threadID`, newThreadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, updateAnyFile);

        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
                let isSingleFile = newAttachedFiles.length === 1;
                this.setState({ updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex), newAttachedFiles: [], removedAttachedFileIndex: -1, threadID: newThreadID, }, async () => {
                    this.manageFilePlaceHolder();
                    if (isRemoveFile) {
                        this.successAlertMessage("Document removed successfully.");
                    } else {
                        this.successAlertMessage(isSingleFile ? `Document uploaded successfully.` : `Documents uploaded successfully.`);
                    }
                    await this.context.updateSessionId(sessionID);
                });
            } else if (!response.FileUpload && response.Files && response.Files.length === 0) {
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                this.setState({ updateAnyFile: true, newAttachedFiles: [], removedAttachedFileIndex: -1, }, async () => {
                    this.manageFilePlaceHolder();
                    await this.context.updateSessionId(sessionID);
                });
            }
            else if (!response.FileUpload && response.Files && response.Files.length > 0) {
                let failedGuid = response.Files.map(x => x.Guid)
                let finalFaileAttached = attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => failedGuid.includes(x.guid));
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${finalFaileAttached.map(x => x.name).join("<br /> - ")}`)
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !failedGuid.includes(x.guid)),
                    newAttachedFiles: [], removedAttachedFileIndex: -1,
                }, async () => {
                    this.manageFilePlaceHolder();
                    await this.context.updateSessionId(sessionID);
                });
            }
            // this.setState({ updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex), newAttachedFiles: [], removedAttachedFileIndex: -1, threadID: newThreadID, chatHistory: [] }, async () => {
            //     this.manageFilePlaceHolder();
            //     await this.context.updateSessionId(sessionID);
            // });

        }).catch((error) => {
            let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
            this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1 }, () => {
                if (isRemoveFile) {
                    this.errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
                } else {
                    this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                }
            });

            console.log(error)
        }).finally(() => {
            this.setState({ isProcessing: false, spinnerMessage: '' });
        });
    }
    generateArrayString = (array) => {
        let arrStr = ''
        array.map((item, index) => {
            if (index === array.length - 1) {
                arrStr += item
            }
            else {
                arrStr += item + ";"
            }
            return null
        })
        return arrStr
    }
    async fileInputChange(event) {
        const files = event.target.files;
        let { attachedFiles } = this.state;

        let isImageUpload = (Object.keys(files).some(x =>
            files[x].name.toLowerCase().endsWith('.gif')
            || files[x].name.toLowerCase().endsWith('.jpeg')
            || files[x].name.toLowerCase().endsWith('.jpg')
            || files[x].name.toLowerCase().endsWith('.png')))
            || (attachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.gif')
                || x.name.toLowerCase().endsWith('.jpeg')
                || x.name.toLowerCase().endsWith('.jpg')
                || x.name.toLowerCase().endsWith('.png')));

        let isDocUpload = (Object.keys(files).some(x =>
            files[x].name.toLowerCase().endsWith('.pdf')
            || files[x].name.toLowerCase().endsWith('.doc')
            || files[x].name.toLowerCase().endsWith('.docx')
            || files[x].name.toLowerCase().endsWith('.ppt')
            || files[x].name.toLowerCase().endsWith('.pptx')))
            || (attachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.pdf')
                || x.name.toLowerCase().endsWith('.doc')
                || x.name.toLowerCase().endsWith('.docx')
                || x.name.toLowerCase().endsWith('.ppt')
                || x.name.toLowerCase().endsWith('.pptx')))

        if ((attachedFiles.length + Object.keys(files).length) > 5) {
            this.errorAlertMessage("You can only upload a maximum of 5 files");
        } else if (isImageUpload && isDocUpload) {
            this.errorAlertMessage("You can upload either image file or document file");
        } else if (isImageUpload && (attachedFiles.length + Object.keys(files).length) > 1) {
            this.errorAlertMessage("You can only upload a maximum of 1 image file");
        } else {
            let _attachedFiles = [];
            let isUploadSuccessfully = true;
            for (var i = 0; i < Object.keys(files).length; i++) {
                let file = files[i];
                if (file.name.toLowerCase().endsWith('.pdf')
                    || file.name.toLowerCase().endsWith('.jpg')
                    || file.name.toLowerCase().endsWith('.jpeg')
                    || file.name.toLowerCase().endsWith('.png')
                    || file.name.toLowerCase().endsWith('.gif')) {
                    file.guid = uuidv4();
                    file.newFileName = file.name;
                    _attachedFiles.push(file);
                } else {
                    this.setState({ isProcessing: true,spinnerMessage: 'Please wait while uploading the document.', attachedFilePopupCollapsed: false });
                    let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/PDFMaker`;
                    if (file.name.toLowerCase().endsWith('.doc') || file.name.toLowerCase().endsWith('.docx')) {
                        API_ENDPOINT += "?fileType=Document"
                    } else {
                        API_ENDPOINT += "?fileType=Presentation"
                    }
                    const formData = new FormData();
                    formData.append('form_filed_name', file)
                    const _headers = {
                        'content-type': 'multipart/form-data'
                    }
                    if (await Authentication.isAccessTokenAvailable()) {
                        const token = await Authentication.getAccessToken();
                        _headers.Authorization = `Bearer ${token}`;
                    }
                    try {
                        const res = await axios.post(API_ENDPOINT, formData, {
                            headers: _headers,
                            responseType: "blob",
                        });
                        let newFileName = file.name.split('.').slice(0, -1).join('.');
                        const fileName = `${newFileName}.pdf`;
                        const data = new Blob([res.data], { type: 'application/pdf' });
                        var newFile = new File([data], file.name, { type: 'application/pdf' });
                        newFile.guid = uuidv4();
                        newFile.newFileName = fileName;
                        _attachedFiles.push(newFile);
                    } catch (error) {
                        console.log(error);
                        isUploadSuccessfully = false;
                    }
                }
                if (!isUploadSuccessfully) {
                    break;
                }
            }
            if (!isUploadSuccessfully) {
                this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1, isProcessing: false, spinnerMessage:'' }, () => {
                    this.errorAlertMessage("Upload failed due to some reason. Kindly try after some time.");
                });
            } else {
                var threadGuid = uuidv4();
                this.setState({ newAttachedFiles: _attachedFiles, newThreadID: threadGuid }, async () => {
                    await this.multipleFilesUpload();
                });
            }
        }
        if (this.inputRef.current) {
            this.inputRef.current.value = null;
        }
    }
    manageFilePlaceHolder() {
        let { attachedFiles } = this.state;
        let uploadFilePlaceHolder = '', uploadFilePlaceHolderTitle = '';
        if (attachedFiles.length > 0) {
            let singleFile = attachedFiles[0];
            uploadFilePlaceHolder = this.getAttachedFileName(singleFile);
            uploadFilePlaceHolderTitle = singleFile.name;
        }
        this.setState({ uploadFilePlaceHolder: uploadFilePlaceHolder, uploadFilePlaceHolderTitle: uploadFilePlaceHolderTitle, isAttachedFile: attachedFiles.length > 0 });
    }
    handleRemoveAllAttachedFile = () => {
        this.setState({
            uploadFilePlaceHolder: "",
            uploadFilePlaceHolderTitle: "",
            attachedFiles: [],
            newAttachedFiles: [],
            isAttachedFile: false,
            focusDropDownCollapsed: false,
            attachedFilePopupCollapsed: false,
            removedAttachedFileIndex: -1,
            updateAnyFile: false,
        }, async () => {
            let { sessionID } = this.state;
            await ts.deleteIndexBySessionId(sessionID);
            await this.context.updateSessionId("");
            this.successAlertMessage("Documents removed successfully.");
        })
    }
    handleRemoveAttachedFile = (index) => {
        let { attachedFiles } = this.state;
        attachedFiles = attachedFiles.filter((file, fileIndex) => fileIndex !== index);
        if (attachedFiles.length > 0) {
            var threadGuid = uuidv4();
            this.setState({ removedAttachedFileIndex: index, newThreadID: threadGuid }, async () => {
                await this.multipleFilesUpload();
            });
        } else {
            this.setState({
                uploadFilePlaceHolder: "",
                uploadFilePlaceHolderTitle: "",
                attachedFiles: [],
                isAttachedFile: false,
                focusDropDownCollapsed: false,
                attachedFilePopupCollapsed: false,
                updateAnyFile: false,
            }, async () => {
                let { sessionID } = this.state;
                await ts.deleteIndexBySessionId(sessionID);
                await this.context.updateSessionId("");
                this.successAlertMessage("Document removed successfully.");
            })
        }
    }
    handleNewQuestion = (e) => {
        this.setState({ newQuestion: e.target.value })
    }

    handleOnClickAttachedFile = () => {
        const { attachedFilePopupCollapsed } = this.state;
        this.setState({ attachedFilePopupCollapsed: !attachedFilePopupCollapsed })
    }
    getAttachedFileName(singleFile) {
        let filename = singleFile.name.split('.').slice(0, -1).join('.');
        let fileExtention = singleFile.name.substring(singleFile.name.lastIndexOf('.') + 1, singleFile.name.length) || singleFile.name;
        filename = this.snippetLongStringForKeyword(filename);
        return `${filename} .${fileExtention}`;;
    }

    snippetLongStringForKeyword = (snippet, strLength = 25) => {
        if (snippet.length > strLength) {
            let text = snippet.substring(0, strLength)//cuts to 70
            text = text + `...`//adds (...) at the end to show that it's cut
            return text
        }
        return snippet;
    }
    handleLeftMouseClick = (e, _id) => {
        const x = e.clientX;
        const y = e.clientY;
        showMenu({
            position: { x, y },
            id: _id
        });
    }

    handleDisclaimerClose = async () => {
        this.setState({ showDisclaimerPopup: false });
    }
    renderFileIcon = (name) => {
        if (name.toLowerCase().endsWith('.pdf')) {
            return (<><img src={GenAiPDFIcon} alt="PDF" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.doc') || name.toLowerCase().endsWith('.docx')) {
            return (<><img src={GenAiDOCIcon} alt="DOC" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.ppt') || name.toLowerCase().endsWith('.pptx')) {
            return (<><img src={GenAiPPTIcon} alt="PPT" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.jpg')
            || name.toLowerCase().endsWith('.jpeg')
            || name.toLowerCase().endsWith('.png')
            || name.toLowerCase().endsWith('.gif')) {
            return (<><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="miter">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5" stroke-width="0" fill="#059cf7" opacity="0.1"></polygon>
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5"></polygon>
                    <rect x="2" y="2" width="20" height="20" rx="0"></rect>
                    <line x1="6.99" y1="7" x2="7" y2="7" stroke-linecap="round" stroke-width="2"></line>
                </g>
            </svg> &nbsp;</>)
        }
        else {
            return (<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" class="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>)
        }
    }
    renderAttachedFile = () => {
        let { attachedFilePopupCollapsed, attachedFiles, isAttachedFile } = this.state;

        return (<div className={attachedFilePopupCollapsed ? "gen-ai-authoring-search-main-attachedfile-wrapper gen-ai-answering-main-attachedfile-open" : "gen-ai-authoring-search-main-attachedfile-wrapper gen-ai-answering-main-attachedfile-close"}>
            <div className="gen-ai-answering-main-attachedfile-header">
                <div className="gen-ai-answering-main-attachedfile-header-title">
                    Attached Files
                </div>
                <div className="gen-ai-answering-main-attachedfile-header-controle">
                    {attachedFiles.length < 5 && <>
                        <label for="answeringAttachedfile" style={{ cursor: "pointer" }} className="gen-ai-answering-main-attachedfile-header-controle-add">
                            <div className="flex items-center leading-none justify-center gap-xs">
                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus" className="svg-inline--fa fa-plus fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"></path>
                                </svg>
                                <div class="text-align-center relative">Add</div>
                            </div>
                        </label>
                        <input type="file" key={isAttachedFile} name="answeringAttachedfile" id="answeringAttachedfile" multiple accept={multiFilesAccept} onChange={e => { this.fileInputChange(e) }} style={{ display: "none" }} />
                        &nbsp;</>}

                    <button type="button" class="gen-ai-answering-main-attachedfile-header-controle-delete" onClick={e => this.handleRemoveAllAttachedFile()}>
                        <div class="flex items-center leading-none justify-center gap-xs">
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" className="svg-inline--fa fa-trash fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path>
                            </svg>
                            <div class="text-align-center relative">Clear</div>
                        </div>
                    </button>
                </div>
            </div>
            <div className="gen-ai-answering-main-attachedfile-items">
                <div className="gen-ai-answering-main-attachedfile-item-wrapper">
                    {
                        attachedFiles.map((fileItem, fileIndex) => {
                            return (<div className="gen-ai-answering-main-attachedfile-item" key={`gen-ai-answering-main-attachedfile-item${fileIndex}`} title={fileItem.name}>
                                <span className="gen-ai-answering-main-attachedfile-item-span">
                                    {this.renderFileIcon(fileItem.name)}
                                    {this.getAttachedFileName(fileItem)}
                                </span>
                                <button style={{ background: "none" }} title="Clear Attached" onClick={e => this.handleRemoveAttachedFile(fileIndex)}>
                                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="xmark" class="svg-inline--fa fa-xmark fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                        <path fill="currentColor" d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"></path>
                                    </svg>
                                </button>
                            </div>)
                        })
                    }
                </div>
            </div>
        </div>)
    }
    handleOnClickReaction = async (index, reaction) => {
        let { chatConversation, } = this.state;
        chatConversation[index].Reaction = reaction;
        await this.setState({
            chatConversation: chatConversation
        })
    }
    handleOnClickFeedback = async (index, feedback) => {
        let { chatConversation, } = this.state;
        chatConversation[index].Feedback = feedback;
        await this.setState({
            chatConversation: chatConversation
        })
    }

    renderChatConversation = () => {
        let { chatConversation, customWidth, customHeight, attachedFiles, sessionID, isMultiQuestionProcessing } = this.state;

        return (<>
            {chatConversation.map((conversation, conversationIndex) => {
                let { Question, OutputAnswer, SourcesMultiFiles,
                    DisplayStringMultiFiles, isMultiFiles, combinedSummaryMultiFiles, Reaction, Feedback,
                    isGetAnyAns, isSuccess, lastCreatedDatehour, threadAttachedFiles,
                    wordLimit, readingLevel } = conversation;
                combinedSummaryMultiFiles = (Array.isArray(combinedSummaryMultiFiles) && combinedSummaryMultiFiles && combinedSummaryMultiFiles.length > 0) ? combinedSummaryMultiFiles.filter(x => x !== 'No answer found in the document') : combinedSummaryMultiFiles;
                return (<React.Fragment key={`GenAIResultIndex-${conversation.eventid}-${conversationIndex}`}>
                    <GenAIAuthoring2ResultIndex eventid={conversation.eventid} customWidth={customWidth} customHeight={customHeight} Question={Question} OutputAnswer={OutputAnswer}
                        Sources={[]} DisplayString={[]}
                        RecommandationResults={[]} conversationIndex={conversationIndex} updateRunGenAISearch={this.updateRunGenAISearch}
                        SourcesMultiFiles={SourcesMultiFiles} DisplayStringMultiFiles={DisplayStringMultiFiles} isMultiFiles={isMultiFiles} attachedFiles={attachedFiles}
                        selectedFilters={[]} renderfilters={[]} CombinedSummaryMultiFiles={combinedSummaryMultiFiles}
                        reaction={Reaction} feedback={Feedback} handleOnClickReaction={this.handleOnClickReaction}
                        sessionID={sessionID} questionType={conversation.questionType} threadID={conversation.threadID}
                        lastCreatedDatehour={lastCreatedDatehour}
                        isGetAnyAns={isGetAnyAns} isSuccess={isSuccess} handleOnClickFeedback={this.handleOnClickFeedback}
                        isComprehensive={false}
                        RelevantInformation={{}} handleOnClickMoreInformation={this.handleOnClickMoreInformation} ShowRelevantInformation={false}
                        threadAttachedFiles={threadAttachedFiles}
                        wordLimit={wordLimit} readingLevel={readingLevel} />
                    {(conversationIndex < chatConversation.length - 1) && <hr style={{ margin: "0 20px" }}></hr>}
                </React.Fragment>)
            })}
            {isMultiQuestionProcessing && <div style={{ margin: "5px 10% 2% 10%" }}>
                <div style={{ fontSize: "12px", textAlign: "center" }} className="gen-ai-search-multi-question-loader">
                    <img src={imsLoader} alt="" width={50} height={50} />
                    <div className="saveModal-heading" style={{ color: "#0074B0" }}>Please wait while we generate answers for other questions.</div>
                    <hr style={{ margin: "5px 20px" }}></hr>
                </div>
            </div>}

            <div style={{ float: "left", clear: "both", height: "100px" }}
                ref={(el) => { this.messagesEnd = el; }}>
            </div>
        </>)


    }
    handleScroll = () => {
        let currScroll = 0;
        if (this.myDiv && this.myDiv.scrollTop) {
            currScroll = this.myDiv.scrollTop;
        }
        this.setState({ scrollingUp: currScroll > 30 })
    }
    _onIdle(e) {
        this.setState({ isTimeOut: true });
    }
    handleClickOnContinue = async () => {
        this.setState({ isTimeOut: false });
        this.idleTimer.reset();
    }
    closeAttachedFilePopupCollapsed = () => {
        this.setState({ attachedFilePopupCollapsed: false })
    }



    handleOnClickAuthoring = async () => {
        let { sessionID, newQuestion, attachedFiles, threadID } = this.state;
        let _newQuestion = newQuestion.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
        if (attachedFiles.length > 0 && _newQuestion.trim().split(/\n\*\|\*\n/g).filter(x => x).length > 10) {
            this.errorAlertMessage("You have exceeded 10 questions. Please remove questions before continuing.");
        } else {
            this.setState({ isRedirectOnGenAISearch: true }, () => {
                let _path = `/genAISearch/${sessionID}`;
                let data = {
                    sessionID: sessionID,
                    newQuestion: newQuestion,
                    attachedFiles: attachedFiles,
                    threadID: threadID,
                    path: _path
                }
                this.props.history.push({
                    pathname: '/GenAIAuthoring',
                    state: data // your data array of objects
                })
            })
        }
    }
    handleShareThread = () => {
        this.setState({ shareModal: true })
    }
    handleShareModalClose = () => {
        this.setState({
            shareModal: false,
        });
    }
    handleIsProcessing = (isProcessing, spinnerMessage) => {
        this.setState({ isProcessing: isProcessing, spinnerMessage: spinnerMessage });
    }
    handleShareThreadToUser = async (sharedToEmail) => {
        let { sessionID } = this.state;
        this.setState({ isProcessing: true, spinnerMessage: "Please wait..." });
        let service = new ApiServices();
        let apiRes = await service.getUserDetailsByUserName(sharedToEmail);
        if (apiRes?.length > 0) {
            let response = await ts.shareAnswerThreadDataBySessionId(UserData.sub, sessionID, apiRes[0]);
            if (response) {
                this.setState({ isProcessing: false, spinnerMessage: "", shareModal: false }, () => {
                    this.indexShareData(sharedToEmail);
                    this.successAlertMessage("The thread shared successfully.")
                });
            } else {
                this.setState({ isProcessing: false, spinnerMessage: "", shareModal: false }, () => {
                    this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");
                });
            }
        } else {
            this.setState({ isProcessing: false, spinnerMessage: "", shareModal: false }, () => {
                this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");
            });
        }
    }
    onClickProceed = async () => {
        let { projectName, projectType, chatConversation } = this.state;
        this.setState({ isProcessing: true, spinnerMessage: 'Please wait while your document is getting downloaded' })
        let service = new ApiServices();
        let fileName = `${projectName}_${this.generateDownloadTimestamp()}.docx`;
        let html = ReactDOMServer.renderToString(<GenAIAnsweringHTMLNotebook projectName={projectName} projectType={projectType} chatConversation={chatConversation} />);
        await service.prepareDocx(html, 'Word').then((res) => {
            const data = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            FileSaver.saveAs(data, fileName);
        })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                this.setState({ isProcessing: false, spinnerMessage: '', saveFormat: "Word" })
            });
    }


    render() {

        let { attachedFiles, scrollingUp, spinnerMessage } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, uploadFilePlaceHolderTitle, uploadFilePlaceHolder } = this.state;
        let { showDisclaimerPopup, showPromptTemplateList, projectName, projectType } = this.state;

        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.props.customWidth > 1000) {
            return (<>
                <div className="gen-ai-answering-search-main" ref={(el) => { this.myDiv = el; }} id="gen-ai-answering-search-main">
                    {/* <GenAIAnsweringHTMLNotebook projectName={this.state.projectName} projectType={this.state.projectType} chatConversation={this.state.chatConversation}/>*/}
                    <header className={`${scrollingUp ? this.context.isCollapsedSpin ? "stickyHeaderCollapse" : "stickyHeaderExpand" : ""}`}>
                        <div className="gen-ai-answering-search-main-header-collection">
                            <div className="gen-ai-authoring-search-main-header-projectinfo">
                                {projectName ? <div title={projectName} className="gen-ai-authoring-search-main-header-projectName">{this.snippetLongStringForKeyword(projectName, 30)}</div> : <div className="gen-ai-authoring-search-main-header-projectName">&nbsp;</div>}
                                {projectType ? <div title={projectType} className="gen-ai-authoring-search-main-header-projectType">{this.snippetLongStringForKeyword(projectType, 30)}</div> : <div className="gen-ai-authoring-search-main-header-projectType">&nbsp;</div>}
                                <div className="gen-ai-authoring-search-main-header-export">
                                    <span>Export</span>

                                    <button className="gen-ai-authoring-search-main-header-export-btn" onClick={this.onClickProceed}><img src={GenAiDOCIcon} alt="Export Word document" style={{ width: "24px" }} /></button>
                                    <button className="gen-ai-authoring-search-main-header-export-btn" onClick={this.handleExportToExcel}><img src={GenAiExcelIcon} alt="Export Excel spreadsheet" style={{ width: "24px" }} /></button>
                                </div>
                            </div>
                            <GenAIClose />
                        </div>
                    </header>
                    {(attachedFiles && attachedFiles.length > 0) &&
                        <IdleTimer
                            key="GenAISearchIndex"
                            ref={ref => { this.idleTimer = ref }}
                            onIdle={this.onIdle}
                            debounce={250}
                            timeout={this.state.timeout}
                            crossTab={{
                                emitOnAllTabs: true
                            }} />}
                    {this.renderChatConversation()}

                    <div className="gen-ai-answering-search-textarea-main">
                        <div className="gen-ai-answering-main-search-question">
                            {/* <div className="gen-ai-answering-main-search-question-txt-btn-section">
                                 <textarea placeholder="Ask follow-up" title="Due to limited access you not able to ask follow-up in this thread." value={newQuestion} disabled={enableTextBox} onKeyDown={this.handleKeyDown} onChange={(e) => this.handleNewQuestion(e)} onClick={(e) => { this.closeAttachedFilePopupCollapsed() }} autocomplete="off" /> 
                                <button type="button" disabled={!newQuestion} className="gen-ai-answering-main-search-action-section-send" onClick={(e) =>
                                    this.handleOnClickSend()}>
                                    <svg fill="#ffffff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="-11.19 -11.19 52.62 52.62" stroke="#ffffff">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0">
                                            <rect x="-11.19" y="-11.19" width="52.62" height="52.62" rx="26.31" fill={!newQuestion ? "#cecece" : "#2a498a"} strokewidth="0"></rect>
                                        </g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <path d="M20.194,3.46c-4.613-4.613-12.121-4.613-16.734,0c-4.612,4.614-4.612,12.121,0,16.735 c4.108,4.107,10.506,4.547,15.116,1.34c0.097,0.459,0.319,0.897,0.676,1.254l6.718,6.718c0.979,0.977,2.561,0.977,3.535,0 c0.978-0.978,0.978-2.56,0-3.535l-6.718-6.72c-0.355-0.354-0.794-0.577-1.253-0.674C24.743,13.967,24.303,7.57,20.194,3.46z M18.073,18.074c-3.444,3.444-9.049,3.444-12.492,0c-3.442-3.444-3.442-9.048,0-12.492c3.443-3.443,9.048-3.443,12.492,0 C21.517,9.026,21.517,14.63,18.073,18.074z"></path>
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>*/}
                            <div className="gen-ai-authoring-main-search-action-section">
                                {<>
                                    <div className="gen-ai-authoring-search-textarea-main-controle-file">
                                        {attachedFiles.length === 0 ? <>
                                            <label for="pdfUploadFile" className="gen-ai-answering-main-action-section-file gen-ai-authoring-main-action-section-file" style={{ cursor: "pointer", marginTop: "5px" }}>
                                                <svg className="svg-inline--fa fa-file fa-fw fa-1x " viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9.81826 7.23019C9.81826 7.23019 9.81817 13.5601 9.81826 15.6701C9.81832 16.9891 10.6361 18.3075 12 18.3075C13.3639 18.3075 14.1818 16.9891 14.1818 15.6701C14.1818 13.5601 14.1818 8.28518 14.1818 6.1752C14.1818 4.06522 11.9438 2.87618 9.81826 3.01024C7.85859 3.13384 6.00018 4.06522 6.00018 6.1752C6.00018 8.28518 5.99977 12.5051 6.00018 15.6701C6.00066 19.3378 8.20735 22 11.9998 22C15.7923 22 17.9995 18.835 17.9999 15.6701C18.0002 12.5051 17.9999 7.23019 17.9999 7.23019" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    </g>
                                                </svg>
                                                <b className="gen-ai-authoring-search-textarea-main-controle-file-bold">Upload Documents</b>
                                            </label>
                                            <><span className="gen-ai-authoring-search-textarea-main-controle-file-msg">*Kindly upload documents for Ask follow-up prompt.</span></>
                                        </> : <div className="gen-ai-authoring-main-action-search-section-send-wrrap">
                                            {this.renderAttachedFile()}
                                            <div className="gen-ai-authoring-main-search-action-section-listfile" onClick={() => this.handleOnClickAttachedFile()}>
                                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" className="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>
                                                <label className="gen-ai-answering-main-action-section-upload" title={uploadFilePlaceHolderTitle} style={{ cursor: "pointer" }} >
                                                    {uploadFilePlaceHolder}</label>
                                            </div>
                                            <button type="button" onClick={() => { this.handleClickOnPromptTemplate() }} className="gen-ai-authoring-prompt-template-shortcut-label">Add Prompt</button>
                                        </div>}

                                        <input type="file"  ref={this.inputRef }  name="pdfUploadFile" id="pdfUploadFile" multiple accept={multiFilesAccept} onChange={e => { this.fileInputChange(e) }} style={{ display: "none" }} />
                                    </div>
                                </>}
                            </div>
                        </div>
                        {/* {attachedFiles.length > 0 && <>{this.renderSystemPromptTemplateShortcut()}</>} */}
                        <div className="gen-ai-answering-follow-up-footer-content">
                            <p>GenAI Answers may display inaccurate information, be sure to verify its responses. <button type="button" className="authoring-model-body-content-link" onClick={() => { this.setState({ showDisclaimerPopup: true }) }} >GenAI Adherence Policy</button></p>
                        </div>

                    </div>
                </div>
                {this.state.isProcessing &&
                    <Modal
                        show={this.state.isProcessing}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="savePopUp"
                        className="gen-ai-answering-search-spinner-popup"
                        backdropClassName="z-index-gen-ai-answering-search-spinner-popup"
                        scrollable={true}>
                        <div style={{ padding: "0 5%" }}>
                            <div style={{ fontSize: "14px", textAlign: "center" }}>
                                <Modal.Body>
                                    <img src={imsLoader} alt="" width={100} height={100} />
                                    <div className="saveModal-heading" style={{ color: "#0074B0" }}>{spinnerMessage ? spinnerMessage : `Please wait while finding answers.`} </div>
                                </Modal.Body>
                            </div>
                        </div>
                    </Modal>}
                {(this.state.shareModal) && <ShareTemplateModal showModal={this.state.shareModal} handleShareThreadToUser={this.handleShareThreadToUser} handleIsProcessing={this.handleIsProcessing} handleClose={() => this.handleShareModalClose()} />}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                {this.state.isTimeOut &&
                    <Modal
                        size="md sm xs"
                        show={this.state.isTimeOut}
                        keyboard={false}
                        dialogClassName="popTimeOut"
                        className="z-index-popTimeOut"
                        backdropClassName="z-index-popTimeOut-backdrop">
                        <div style={{ borderLeft: `5px solid #2EB000` }}>
                            <Modal.Body>
                                Press Continue button, otherwise session will end.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button text="Continue" customColor='#2EB000' action={
                                    this.handleClickOnContinue
                                } />
                            </Modal.Footer>
                        </div>
                    </Modal>
                }
                {/*showPromptTemplateList && <PromptTemplateListPopUp showModal={showPromptTemplateList} handleClose={this.handleClosePromptTemplateList}
                    width={this.props.customWidth} commandText={this.state.newQuestion} handleAddToPromptTemplateText={this.handleAddToPromptTemplateText}
                    isUserPromptTemplate={this.state.isUserPromptTemplate} isSystemPromptTemplate={this.state.isSystemPromptTemplate} isFromGlobalFeaturesMenu={this.state.isFromGlobalFeaturesMenu}
                />*/}
                {showPromptTemplateList && <PromptTemplateListPopUpAuth2 processFollowUpMultiPrompts={this.processFollowUpMultiPrompts} showPromptTemplateList={showPromptTemplateList} prompts={this.state.prompts} handleClose={() => { this.setState({ showPromptTemplateList: false }) }} />}
                {showDisclaimerPopup && <GenAIAnsweringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={this.handleDisclaimerClose} />}
            </>)
        }
    }

}
export default withRouter(GenAIAuthoring2SearchIndex);